import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";
import DateFilters from "../../views/DateFilters";
import { actionCreators } from "../../redux/sagas/marketing";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import KBLearnMore from "../../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../../constants/ilearnUrls";

const IntroRevenue = (props) => {
  const dispatch = useDispatch();
  const { moduleName, chartContentTitle } = props;
  const { toggleView, updateFilters, updateReferralToggle, updateData, fetchData } =
    actionCreators(moduleName);

  const {
    dataTable: { rows = [], cols = [] },
    initialRequest,
    options,
    isTable,
    isLoading,
    filters
  } = useSelector((state) => state[moduleName]);

  // switch between table and chart views
  const switchView = (view) => dispatch(toggleView({ moduleName, view, filters }));

  useEffect(() => {
    !initialRequest && dispatch(fetchData(props));
  }, []);
  let content = () => {
    return (
      <div id="module-date-filters" data-testid={moduleName}>
        <DateFilters
          moduleName={moduleName}
          actionCreators={{ updateFilters, updateReferralToggle, updateData, fetchData }}
        />
        <div className="chart-root">
          <GoogleChart
            chartName="intro_revenue_chart"
            isTableView={isTable}
            enableEventListeners
            height={400}
            chartType={isTable ? "Table" : "ColumnChart"}
            rows={rows}
            columns={cols}
            switchView={switchView}
            options={options}
            showAdditionTooltip={false}
          />
        </div>
      </div>
    );
  };

  return (
    <SectionToggle
      isLoading={isLoading}
      height={400}
      title={chartContentTitle}
      content={content()}
      learnMore={
        <KBLearnMore
          title={chartContentTitle}
          description="This report shows all revenue collected from Intro Offers within your selected date range. These insights help you understand how introductory products contribute to early-stage revenue and how trends shift month to month."
          kbUrl={ILEARN_URLS.marketing.introRevenue}
        />
      }
    />
  );
};

export default React.memo(IntroRevenue);
